import React from 'react';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import CardHeader from '@material-ui/core/CardHeader';
import ViewComfy from '@material-ui/icons/ViewComfy';
import CardContent from '@material-ui/core/CardContent';
import InputComp from '../InputComp';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import Snackbar from '@material-ui/core/Snackbar';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Chip from '@material-ui/core/Chip';

const ProductOperatorGroupsForm = (props) => {
  // const {handleImageInput, storeTemporaryProductLabelImage, tempImage} = props;
  return (
    <div className="col-md-12">
      <Card>
        <CardHeader
          avatar={
            <IconButton>
              <ViewComfy/>
            </IconButton>
          }
          title="Create new operator group"
        />
        <CardContent>
          <div className="col col-lg-4 offset-lg-3">
            <form id="form-productOperatorGroupLabel" className="form-horizontal" onSubmit={props.handleSubmit}>
              <InputComp Value={props.name} Label="Name" Name="name" Type="text"
                         Required={true}
                         fullWidth={true} margin={'normal'}
                         placeholder="name"
                         PropHandleInputChange={(evt) => props.setField(evt.target.name, evt.target.value)} />
            </form>
          </div>
          <CardActions>
            <Button
              disabled={!props.name}
              color="primary"
              variant="contained"
              form="form-productOperatorGroupLabel"
              type="submit">Create</Button>
          </CardActions>
        </CardContent>
      </Card>
      <Snackbar
        open={props.formWarningOpen}
        message={props.formWarningOpen}
        autoHideDuration={6000}
      />
    </div>
  );
};

export default ProductOperatorGroupsForm;



// WEBPACK FOOTER //
// ./src/components/OperatorGroups/ProductOperatorGroupsForm.js